import { createStore } from "@stencil/store";
import { IStatusCode } from "../utils/types";
import statusCodes from "./status-codes.json";

export interface IStatusCodesState {
  [key: string]: IStatusCode;
}

const { state: statusCodesState } = createStore<IStatusCodesState>({
  ...(statusCodes as { [key: string]: IStatusCode }),
});

// This file simply populates the data from status-codes.json into a store and exports the state
export default statusCodesState;
